import settings from '@/settings'

let insert = (data, headers) => {
  return fetch(`${settings.apetrusApi}/politicasprivacidade/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let list = (pagination, headers) => {
  return fetch(`${settings.apetrusApi}/politicasprivacidade/?page=${pagination.page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let info = (id, headers) => {
  return fetch(`${settings.apetrusApi}/politicasprivacidade/${id}/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let deletar = (id, headers) => {
  return fetch(`${settings.apetrusApi}/politicasprivacidade/${id}/`, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  insert,
  list,
  info,
  deletar
}
